import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

declare global {
  interface Window {
    Pusher: typeof Pusher
    Echo: Echo<'pusher'>
  }
}

export default defineNuxtPlugin(() => {
  const config = useNuxtApp().$config

  const authStore = useAuthStore()

  const route = useRoute()

  window.Pusher = Pusher
  window.Echo = new Echo<'pusher'>({
    broadcaster: 'pusher',
    key: config.public.pusher.app_key,
    wsHost: config.public.pusher.host,
    wsPort: parseInt(config.public.pusher.port),
    wssPort: parseInt(config.public.pusher.port),
    cluster: config.public.pusher.cluster,
    forceTLS: true,
    channelAuthorization: {
      transport: 'ajax',
      endpoint: config.public.api_base_url + '/broadcasting/auth',
      headersProvider: () => {
        let token = null

        const isTablet = route.path.startsWith('/tablet')
        if (isTablet) {
          token = useLocalStorage('tablet_token', useCookie('tablet_token').value ?? null).value
        }
        else {
          token = authStore.getToken()
        }

        if (token) {
          return { Authorization: `Bearer ${token}` }
        }
      },
    },
  })
})
